import './modals'
import './flashMessages'

import initMasks     from './masks'
import initDate      from './datePicker'
import clearForm     from './clearForm'
import select2Setup  from './select2Setup'
import initSwitchBtn from './switchButton'

export const initApp = () => {
  select2Setup();
  initMasks();
  initDate();
  clearForm();
  initSwitchBtn();

  $('[data-bs-toggle="tooltip"]').tooltip();

}

// $.ajaxSetup({headers: { 'X-CSRF-Token': Rails.csrfToken() }})

window.initApp = initApp;
document.addEventListener("turbolinks:load", () => initApp());
